import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import DatePickerField from '../../../../../components/general/fields/datePickerField';
import dayjs from 'dayjs';
import { SarlaftPersonNaturalProps } from './props';
import { useSarlaftPersonNatural } from './hook';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const SarlaftPersonNatural = (props: SarlaftPersonNaturalProps) => {
    const { formik, typesClients, cities, isSalaried } =
        useSarlaftPersonNatural(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Persona natural
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Código asegurado"
                    name="insuredCode"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.insuredCode}
                    errors={formik.errors.insuredCode}
                    value={formik.values.insuredCode}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Edad"
                    name="age"
                    size="small"
                    required
                    disabled
                    onBlur={formik.handleBlur}
                    touched={formik.touched.age}
                    errors={formik.errors.age}
                    value={formik.values.age}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typesClients)}
                    label="Tipo de cliente"
                    name="typeClient"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typeClient}
                    errors={formik.errors.typeClient}
                    value={formik.values.typeClient}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typeClient', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="CIIU"
                    name="ciiu"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.ciiu}
                    errors={formik.errors.ciiu}
                    value={formik.values.ciiu}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(cities)}
                    label="Lugar de expedición"
                    name="placeIssue"
                    size="small"
                    onBlur={formik.handleBlur}
                    value={formik.values.placeIssue}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('placeIssue', value)
                    }
                    errors={formik.errors.placeIssue}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de expedición"
                    name="dateIssue"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    value={
                        formik.values.dateIssue
                            ? dayjs(formik.values.dateIssue)
                            : null
                    }
                    onChange={(value) =>
                        formik.setFieldValue(
                            'dateIssue',
                            value ? value.toString() : undefined,
                            true
                        )
                    }
                    errors={formik.errors.dateIssue}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(cities)}
                    label="Lugar de nacimiento"
                    name="placeBirth"
                    size="small"
                    onBlur={formik.handleBlur}
                    value={formik.values.placeBirth}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('placeBirth', value)
                    }
                    errors={formik.errors.placeBirth}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <DatePickerField
                    label="Fecha de nacimiento"
                    name="dateBirth"
                    size="small"
                    maxDate={dayjs().endOf('day')}
                    value={
                        formik.values.dateBirth
                            ? dayjs(formik.values.dateBirth)
                            : null
                    }
                    onChange={(value) =>
                        formik.setFieldValue(
                            'dateBirth',
                            value ? value.toString() : undefined,
                            true
                        )
                    }
                    errors={formik.errors.dateBirth}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Nacionalidad"
                    name="nationality"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.nationality}
                    errors={formik.errors.nationality}
                    value={formik.values.nationality}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Ocupación / Oficio"
                    name="occupation"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.occupation}
                    errors={formik.errors.occupation}
                    value={formik.values.occupation}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Profesión"
                    name="profession"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.profession}
                    errors={formik.errors.profession}
                    value={formik.values.profession}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Empresa"
                    name="company"
                    size="small"
                    required={isSalaried ? true : false}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.company}
                    errors={formik.errors.company}
                    value={formik.values.company}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Área"
                    name="area"
                    size="small"
                    required={isSalaried ? true : false}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.area}
                    errors={formik.errors.area}
                    value={formik.values.area}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Cargo"
                    name="charge"
                    size="small"
                    required={isSalaried ? true : false}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.charge}
                    errors={formik.errors.charge}
                    value={formik.values.charge}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Dirección"
                    name="adress"
                    size="small"
                    required={isSalaried ? true : false}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.adress}
                    errors={formik.errors.adress}
                    value={formik.values.adress}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(cities)}
                    label="Ubicación"
                    name="typeClient"
                    size="small"
                    required={isSalaried ? true : false}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.location}
                    errors={formik.errors.location}
                    value={formik.values.location}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('location', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Fax empresa"
                    name="faxCompany"
                    size="small"
                    required={isSalaried ? true : false}
                    onBlur={formik.handleBlur}
                    value={formik.values.faxCompany}
                    onChange={formik.handleChange}
                    errors={formik.errors.faxCompany}
                />
            </Grid>
        </Grid>
    );
};
